import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface Series {
  SERIES_NAME: string;
  _id: string;
}

interface SeriesState {
  data: Series[];
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedSeries: string[];
  selectedSeriesList: string[];
}
const initialState: SeriesState = {
  data: [],
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
  selectedSeries: [],
  selectedSeriesList: [],
};

export const fetchSeries = createAsyncThunk(
  "fetchSeries",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHSERIES, data);
      return response;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const SeriesSlice = createSlice({
  name: "SeriesData",
  initialState,
  reducers: {
    UpdateSelectedSeries: (state, action) => {
      state.selectedSeries = action.payload;
    },
    UpdateSelectedSeriesList: (state, action) => {
      state.selectedSeriesList = action.payload;
    },
    emptySeriesReducer: (state) => {
      state.data = initialState.data;
      state.status = initialState.status;
      state.error = initialState.error;
      state.statusCode = initialState.statusCode;
      state.isLoading = initialState.isLoading;
      state.selectedSeries = initialState.selectedSeries;
      state.selectedSeriesList = initialState.selectedSeriesList;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSeries.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(fetchSeries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data;
      })
      .addCase(fetchSeries.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const {
  UpdateSelectedSeries,
  UpdateSelectedSeriesList,
  emptySeriesReducer,
} = SeriesSlice.actions;
export default SeriesSlice.reducer;


